
import { QuestionBase, QuestionBaseParams, QuestionUITypes } from './question-base';
import { FormControl, FormGroup, Validators, ValidatorFn, AsyncValidator, AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import * as moment from 'moment';

export class ButtonQuestion extends QuestionBase<string> {
  public questionType: QuestionUITypes = QuestionUITypes.BUTTON;
  public executeId?: string;

  constructor(questionParams: QuestionBaseParams<string>) {
    super(questionParams);
  }

  public getValidators() : Array<ValidatorFn> {
    let validators = super.getValidators();
    switch( this.key ){
      case 'geburtsdatum':
        //Because we use special bootstrap date picker
        //validators.push( ( control: AbstractControl ) => { return this.dateValid( control ) } );
      break;
    }

    return validators;
  }

  public getValidatorsAsync() : Array<AsyncValidatorFn> {
    return [];
  }

  public getValueForRequest() : string{
    return this.getAvailableValue();
  }
}


// WEBPACK FOOTER //
// ./src/app/question-button.ts